import {Component, OnDestroy, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {Localiser} from "../../services/localiser";
import {Navigation} from "../../services/navigation.service";
import {UserService} from "../../services/user.service";
import {luminaria} from "../../models/luminaria";
import {LuminariaService} from "../../services/luminaria.service";
import {ProyectoService} from "../../services/proyecto.service";
import {PlanoService} from "../../services/plano.service";
import {ZonaService} from "../../services/zona.service";
import {plano} from "../../models/plano";
import {zona} from "../../models/zona";
import {firmware} from "../../models/firmware";
import {FirmwareService} from "../../services/firmware.service";
import {OtaService} from "../../services/ota.service";
import {Observable} from "rxjs";
import {WebSocketService} from "../../services/web-socket.service";
import {concentrador} from "../../models/concentrador";
import {ConcentradorService} from "../../services/concentrador.service";

@Component({
  selector: 'app-ota',
  templateUrl: './ota.component.html',
  styleUrls: ['./ota.component.css']
})
export class OtaComponent implements OnInit, OnDestroy {

  luminarias: Array<luminaria> = [];
  luminariasFiltro: Array<luminaria> = [];
  luminariasReal: Array<luminaria> = [];
  searcherLuminarias: string = "";

  planos: Array<plano>;
  zonas: Array<zona>;
  concentradores: Array<concentrador>;
  showZonas = [];
  planoSelected: plano;
  zonaSelected: zona;
  versionFilterSelected = undefined;
  versiones: Array<string> = [];
  firmwares: Array<firmware> = [];
  // Text typed in the firmware dropdown searcher, and the luminaire whose dropdown is open
  searcherFirmwares: string = "";
  searcherFirmwaresLum: string = "";
  // Order of the firmware dropdown: 0 = as received, 1 = ascending, 2 = descending
  sortFirmwares: number = 1;
  // Should be just one
  lumForOTA: Array<luminaria> = [];
  finishedOTALums: Array<luminaria> = [];
  queueOTALums: Array<luminaria> = [];
  firstLumInQueue: luminaria = undefined;
  selectedPeripheralLuminaire: luminaria = undefined;
  peripheralColumns = [
    { key: 'nvm', label: 'nvm', tooltip: 'peripherals.nvm' },
    { key: 'sst25', label: 'sst25', tooltip: 'peripherals.sst25' },
    { key: 'crypto_sw', label: 'crypto_sw', tooltip: 'peripherals.crypto_sw' },
    { key: 'crypto_hw', label: 'crypto_hw', tooltip: 'peripherals.crypto_hw' },
    { key: 'dali', label: 'dali', tooltip: 'peripherals.dali' },
    { key: 'emg', label: 'emg', tooltip: 'peripherals.emg' },
    { key: 'h420', label: 'h420', tooltip: 'peripherals.h420' },
    { key: 'relay', label: 'relay', tooltip: 'peripherals.relay' },
    { key: 'wdt', label: 'wdt', tooltip: 'peripherals.wdt' },
    { key: 'klc', label: 'klc', tooltip: 'peripherals.klc' },
    { key: 'dfrobot', label: 'dfrobot', tooltip: 'peripherals.dfrobot' },
    { key: 'ekmc', label: 'ekmc', tooltip: 'peripherals.ekmc' },
    { key: 'innosent', label: 'innosent', tooltip: 'peripherals.innosent' },
    { key: 'fc', label: 'fc', tooltip: 'peripherals.fc' }
  ];

  openFinishedList: boolean = true;
  openQueueList: boolean = true;

  reloadLumsInterval;
  reloading: boolean = false;
  automaticOTAstarted : boolean = false;
  observableOTA!: Observable<any>;

  constructor(public localiser: Localiser, private navigation: Navigation, public user: UserService,
              private luminariaService: LuminariaService, private proyectoService: ProyectoService,
              private planoService: PlanoService, private zonaService: ZonaService,
              private firmwareService: FirmwareService, private otaService: OtaService,
              public webSocketService: WebSocketService, private concentradorService: ConcentradorService) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("ota");
      this.toLocations();
    } else {
      proyectoService.setLastPage("ota")
    }
    this.observableOTA = this.webSocketService.getOberserverOTA();
    this.observableOTA.subscribe(result => {
      this.addDynamicOTA(result);
    });
  }

  ngOnInit(): void {
    this.getLuminarias();
    this.getPlanos();
    this.getZonas();
    this.getFirmwares();
    this.getConcentradores();
  }

  ngOnDestroy() {
    clearInterval(this.reloadLumsInterval);
  }

  addDynamicOTA(result) {
    console.log(result.estado)
    this.luminariasReal.filter(lum => lum.idDispositivo == result.idDispositivo)[0].otaEstado.estado = result.estado;
    this.checkAllFilters();
    if (result.estado == "Done") {
      // The version the luminary reports after rebooting travels with the luminaria, not with
      // this message, so ask for it now instead of showing the old one until the next reload
      this.getLuminarias();
    }
  }

  startReloadLums() {
    this.reloading = true;
    this.reloadLumsInterval = setInterval(() => {
      this.getLuminarias();
    }, 60000);
  }

  stopReloadLums() {
    this.reloading = false;
    clearInterval(this.reloadLumsInterval);
  }

  getLuminarias() {
    this.luminariaService.getByIdProyectoWithPerifericos(this.proyectoService.getProyectoActual().idProyecto).subscribe((response: Array<luminaria>) => {
      this.luminariasReal = response;
      this.luminariasFiltro = this.luminariasReal;
      this.checkAllFilters();
      this.getVersiones();
    });
  }

  mergeLuminariesWithPeripherals(updatedLuminarias: Array<luminaria>) {
    const existingPeripheralsById = new Map<string, any>();
    for (const lum of this.luminariasReal) {
      existingPeripheralsById.set(lum.idDispositivo, lum.perifericos);
    }

    return updatedLuminarias.map((lum) => {
      if (lum.perifericos == null && existingPeripheralsById.has(lum.idDispositivo)) {
        lum.perifericos = existingPeripheralsById.get(lum.idDispositivo);
      }
      return lum;
    });
  }

  setSelectedLumsList() {
    this.luminarias = this.luminariasFiltro.filter(
      luminaria => luminaria.otaEstado != null && (luminaria.otaEstado.estado == "Unselected" || luminaria.otaEstado.estado == "0"));
    let selected = this.luminariasReal.filter(
      luminaria => luminaria.otaEstado != null && luminaria.otaEstado.estado != "Unselected" && luminaria.otaEstado.estado != "0");

    this.queueOTALums = selected.filter(lum => lum.otaEstado.estado == "Selected");
    this.queueOTALums = this.queueOTALums.sort((lum_a, lum_b) => lum_a.otaEstado.orden_ota - lum_b.otaEstado.orden_ota);
    this.finishedOTALums = selected.filter(lum => lum.otaEstado.estado == "Done" || lum.otaEstado.estado.includes("Error"));
    this.lumForOTA = selected.filter(lum => lum.otaEstado.estado != "Selected" && lum.otaEstado.estado != "Done"
      && !lum.otaEstado.estado.includes("Error"));

    if (this.lumForOTA.filter(lum => lum.otaEstado.tipo_ota === "auto").length) {
      this.automaticOTAstarted = true;
    }

    if (!this.automaticOTAstarted) {
      if (this.queueOTALums.filter(lum => lum.otaEstado.tipo_ota === "auto").length) {
        this.automaticOTAstarted = true;
      }
    }

    if (this.lumForOTA.length > 0) {
      this.firstLumInQueue = undefined;
      if (this.lumForOTA.length > 1) {
        this.lumForOTA = this.lumForOTA.sort(function (a, b) {
          return a.otaEstado.estado != "Installing" ? -1 : 1
        });
      }
      if (!this.reloading) {
        this.startReloadLums();
      }
    }

  }

  moveToTop(idDispositivo: string) {
    const index = this.queueOTALums.findIndex(item => item.idDispositivo === idDispositivo);
    if (index > -1) {
      const [item] = this.queueOTALums.splice(index, 1);  // Remove item from original position
      this.queueOTALums.unshift(item);                   // Insert at the top
    }
  }

  getPlanos() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<plano>) => {
      this.planos = result;
    })
  }

  getZonas() {
    this.zonaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<zona>) => {
      this.zonas = result;
    })
  }

  getFirmwares() {
    this.firmwareService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<firmware>) => {
      this.firmwares = result;
    })
  }

  getConcentradores() {
    this.concentradorService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: Array<concentrador>) => {
      this.concentradores = result;
    })
  }

  getVersiones() {
    this.versiones = [];
    for (let luminaria of this.luminarias) {
      let version = luminaria.versionFirmware;
      if (this.versiones.find(ver => ver == version) == undefined) {
        this.versiones.push(version);
      }
    }
  }

  selectPlano(planoEv) {
    if (planoEv == -1 || planoEv == null || planoEv == "all") {
      this.planoSelected = undefined;
      this.zonaSelected = undefined;
      this.showZonas = [];
    } else {
      this.planoSelected = this.planos.find(plano => plano.idPlano == planoEv.idPlano);
      this.zonaSelected = undefined;
      this.showZonas = this.zonas.filter(zona => {
        return zona.idPlano == this.planoSelected.idPlano;
      });
    }
    this.checkAllFilters();
  }

  selectZona(zonaEv) {
    if (zonaEv == -1 || zonaEv == null || zonaEv == "all") {
      this.zonaSelected = undefined;
    } else {
      this.zonaSelected = this.showZonas.find(zona => zona.id == zonaEv.id);
    }
    this.checkAllFilters();
  }

  selectVersionFilter(version) {
    if (version == "all") {
      this.versionFilterSelected = undefined;
    } else {
      this.versionFilterSelected = version;
    }
    this.checkAllFilters();
  }

  checkAllFilters() {
    // Get all luminarias
    this.luminariasFiltro = this.luminariasReal;

    // Filter by selected plano
    if (this.planoSelected != undefined) {
      this.luminariasFiltro = this.luminariasFiltro.filter(luminaria => luminaria.idPlano == this.planoSelected.idPlano);
    }

    // Filter by selected zona
    if (this.zonaSelected != undefined) {
      this.luminariasFiltro = this.luminariasFiltro.filter(luminaria => luminaria.idZona == this.zonaSelected.id);
    }

    // Filter by selected version
    if (this.versionFilterSelected != undefined) {
      this.luminariasFiltro = this.luminariasFiltro.filter(luminaria => luminaria.versionFirmware == this.versionFilterSelected);
    }

    // Filter by input name or ID
    this.luminariasFiltro = this.luminariasFiltro.filter(luminaria =>
      (luminaria.nombre.toLowerCase().includes(this.searcherLuminarias.toLowerCase())) ||
      (luminaria.idDispositivo.toLowerCase().includes(this.searcherLuminarias.toLowerCase())));

    // Divide in columns and print state
    this.setSelectedLumsList();
  }

  changeSelectLum(luminaria: luminaria) {
    if (luminaria == this.firstLumInQueue) {
      this.firstLumInQueue = undefined;
    }
    if (this.checkSelectedLuminaria(luminaria)) {
      luminaria.otaEstado.estado = 'Unselected';
      this.setLuminariaSelected(luminaria.idDispositivo, false);
    } else {
      luminaria.otaEstado.estado = 'Selected';
      this.setLuminariaSelected(luminaria.idDispositivo, true);
    }
    this.setSelectedLumsList();

    if (this.queueOTALums.length == 0 && this.automaticOTAstarted) {
      this.automaticOTAstarted = false;
    }
  }
  setLumForOTA(luminaria: luminaria) {
    this.firstLumInQueue = luminaria;
    this.otaService.setSort(luminaria.idDispositivo).subscribe(response => {
      this.luminariasReal = this.mergeLuminariesWithPeripherals(JSON.parse(response));
      this.luminariasFiltro = this.luminariasReal;
      this.checkAllFilters();
      this.getVersiones();
    });
    this.setSelectedLumsList();
  }

  setLuminariaSelected(idDispositivo: string, selected: boolean) {
    this.otaService.setSelected(idDispositivo, selected).subscribe(result => { })
  }

  checkSelectedLuminaria(luminaria) {
    return luminaria.otaEstado.estado != "Unselected" && luminaria.otaEstado.estado != "0";
  }

  openPeripherals(luminaria: luminaria, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    if (this.selectedPeripheralLuminaire && this.selectedPeripheralLuminaire.idDispositivo === luminaria.idDispositivo) {
      this.selectedPeripheralLuminaire = undefined;
      return;
    }
    this.selectedPeripheralLuminaire = luminaria;
  }

  closePeripherals() {
    this.selectedPeripheralLuminaire = undefined;
  }

  getPeripheralState(luminaria: luminaria, key: string): number {
    if (!luminaria) {
      return -1;
    }

    const latestLum = this.luminariasReal.find(lum => lum.idDispositivo === luminaria.idDispositivo) || luminaria;
    if (!latestLum.perifericos || latestLum.perifericos[key] == undefined) {
      return -1;
    }
    return latestLum.perifericos[key];
  }

  getPlanoNameById(idPlano) {
    if (this.planos != undefined) {
      let plano = this.planos.find(plano => plano.idPlano == idPlano);
      if (plano != undefined) {
        return plano.nombre;
      } else {
        return '---';
      }
    }

    return '---';
  }

  getZonaNameById(idZona) {
    if (this.zonas != undefined) {
      let zona = this.zonas.find(zona => zona.id == idZona);
      if (zona != undefined) {
        return zona.nombre;
      } else {
        return '---';
      }
    }

    return '---';
  }

  getStatusText(luminaria) {
    if (luminaria.otaEstado.estado.includes("Updating")) {

      //let split = luminaria.otaEstado.estado.split('_')
      //let porcentaje = Math.round(split[1] / split[2] * 100);

      let json: JSON = JSON.parse(luminaria.otaEstado.estado.split('_')[1]);
      if (json != undefined && JSON.stringify(json) != "") {
        let porcentaje = Math.round(+json["nFrag"] / +json["nFragTotal"] * 100);
        if (porcentaje == 100) {
          return this.localiser.get("ota.statusValidating");
        }
      }
      return this.localiser.get("ota.statusUpdating");
    } else if (luminaria.otaEstado.estado == 'Connecting') {
      return this.localiser.get("ota.statusConnecting");
    } else if (luminaria.otaEstado.estado == 'Waiting') {
      return this.localiser.get("ota.statusWaiting");
    } else if (luminaria.otaEstado.estado == 'Installing') {
      return this.localiser.get("ota.statusInstalling");
    } else if (luminaria.otaEstado.estado == 'Done') {
      return this.localiser.get("ota.statusDone");
    } else if (luminaria.otaEstado.estado == 'Aborting') {
      return this.localiser.get("ota.statusAborting");
    } else if (luminaria.otaEstado.estado.includes('Error')) {
      return this.localiser.get("ota.statusError") + " " + this.showErrorCode(luminaria);
    }
  }

  getProgress(luminaria) {
    if (luminaria.otaEstado.estado.includes("Updating")) {
      let split = luminaria.otaEstado.estado.split('-')
      let progressBar: HTMLElement = document.getElementById('progressBar-' + luminaria.idDispositivo);
      let porcentaje = Math.round(split[1] / split[2] * 100);
      progressBar.style.height = (porcentaje * 0.96) + "%";
      return porcentaje;
    } else if (luminaria.otaEstado.estado == "Installing") {
      let progressBar: HTMLElement = document.getElementById('progressBar-' + luminaria.idDispositivo);
      let porcentaje = 100;
      progressBar.style.height = "96%";
      return porcentaje;
    }
    return 0;
  }

  getProgressNew(luminaria) {
    if (luminaria.otaEstado.estado.includes("Updating")) {
      let json: JSON = JSON.parse(luminaria.otaEstado.estado.split('_')[1]);
      if (json != undefined && JSON.stringify(json) != "") {
        let progressBar: HTMLElement = document.getElementById('progressBar-' + luminaria.idDispositivo);
        let porcentaje = Math.round(+json["nFrag"] / +json["nFragTotal"] * 100);
        progressBar.style.height = (porcentaje * 0.96) + "%";
        return porcentaje;
      }
    } else if (luminaria.otaEstado.estado == "Installing") {
      let progressBar: HTMLElement = document.getElementById('progressBar-' + luminaria.idDispositivo);
      let porcentaje = 100;
      progressBar.style.height = "96%";
      return porcentaje;
    }
    return 0;
  }

  getRSSIOta(luminaria) {
    if (luminaria.otaEstado.estado.includes("Updating")) {
      console.log(luminaria.otaEstado.estado.split('_'))
      console.log(luminaria.otaEstado.estado.split('_')[1])
      console.log(JSON.parse(luminaria.otaEstado.estado.split('_')[1]))
      let json: JSON = JSON.parse(luminaria.otaEstado.estado.split('_')[1]);
      if (json != undefined && JSON.stringify(json) != "") {
        return json["RSSI"];
      }
    }
    return 0;
  }

  getLossRateOta(luminaria) {
    if (luminaria.otaEstado.estado.includes("Updating")) {
      let json: JSON = JSON.parse(luminaria.otaEstado.estado.split('_')[1]);
      if (json != undefined && JSON.stringify(json) != "") {
        let lossRatePCG = (json["nPacketsFailed"] / json["nPacketsSent"]) * 100;
        return Math.round(lossRatePCG * 100) / 100;
      }
    }
    return 0;
  }

  getLossRateFractionOta(luminaria) {
    if (luminaria.otaEstado.estado.includes("Updating")) {
      let json: JSON = JSON.parse(luminaria.otaEstado.estado.split('_')[1]);
      if (json != undefined && JSON.stringify(json) != "") {
        return json["nPacketsFailed"] + "/" + json["nPacketsSent"];
      }
    }
    return "0/0";
  }

  showErrorCode(luminaria) {
    if (luminaria.otaEstado.estado.includes("Error")) {
      let errorCode = luminaria.otaEstado.estado.split("_")[1];
      switch (errorCode) {
        case '-1':
          return 'NET_DEFAULT_ERR';
        case '-2':
          return 'NET_SERIAL_TIMEOUT_ERR';
        case '-3':
          return 'NET_SERIAL_READ_ERR';
        case '-4':
          return 'NET_SERIAL_WRITE_ERR';
        case '-5':
          return 'NET_SERIAL_JSON_BAD_FMT_ERR';
        case '-6':
          return 'NET_SERIAL_JSON_BAD_KEY_ERR';
        case '-7':
          return 'NET_SERIAL_BAD_ACK_ERR';
        case '-8':
          return 'NET_SERIAL_NO_RESPONSE_ERR';
        case '-9':
          return 'NET_EMB_NO_RESPONSE_ERR';
        case '-10':
          return 'NET_SQL_ERR';
        case '-11':
          return 'OTA_LAUNCHING_ERR';
        case '-12':
          return 'OTA_FRAGMENT_NUMBER_ERR';
        case '-13':
          return 'OTA_HASH_ERR';
        case '-14':
          return 'OTA_ASK_FLASH_ERR';
        case '-15':
          return 'OTA_BOOT_ERR';
        case '-16':
          return 'OTA_NO_BIN_FILE';
        case '-17':
          return 'BAD_MQTT_CLIENT_ERR';
        case '-18':
          return 'NO_BROKER_COMM_ERR';
        case '-19':
          return 'NO_MQTT_THREAD_ERR';
        case '-20':
          return 'NO_PUB_MQTT_ERR';
        case '-21':
          return 'OTA_INVALID_MAC';
        case '-22':
          return 'OTA_ABORTED_BY_USER';
        case '-23':
          return 'OTA_DISCONNECTED_MAC';
        case '-301':
          return 'FIRMWARE_NOT_SELECTED';
        case '-302':
          return 'TIMEOUT ERROR';
        default:
          return 'UNDEFINED ERROR';
      }
    }
  }

  showButtonOTA() {
    if (this.lumForOTA.length == 0 && !this.automaticOTAstarted) {
      return true;
    }
    return false;
  }

  showButtonAbortOTA() {
    if (this.lumForOTA.length > 0) {
      if (this.automaticOTAstarted)
        return true;

      for (let lum of this.lumForOTA) {
        if (lum.otaEstado.estado.includes("Waiting") ||
            lum.otaEstado.estado.includes("Connecting") ||
            lum.otaEstado.estado.includes("Updating") /*||
            lum.otaEstado.tipo_ota.includes("auto")*/)
        {
          return true;
        }
      }
    }
    return false;
  }

  getFirmwaresByLum(luminaria: luminaria) {
    let gw = this.concentradores.find(concentrador => concentrador.idDispositivo == luminaria.idConcentradorPpal)
    if (gw != undefined) {
      // Only the dropdown that is currently open gets filtered by the searcher
      let searcher = luminaria.idDispositivo == this.searcherFirmwaresLum ? this.searcherFirmwares.trim().toLowerCase() : "";
      let firmwares = this.firmwares
        .filter(firmware => firmware.idConcentrador == gw.concentradorMantenimiento
          && (searcher == "" || firmware.nombre.toLowerCase().includes(searcher)))
      if (this.sortFirmwares != 0) {
        let order = this.sortFirmwares == 1 ? 1 : -1;
        firmwares.sort((a, b) => order * a.nombre.localeCompare(b.nombre, undefined, { numeric: true, sensitivity: 'base' }))
      }
      return firmwares;
    } else {
      return [];
    }
  }

  /*
    When the luminary last finished an OTA successfully. The backend only stores it since
    the OTAs it could recover from the OTA history, so luminaries updated long ago and
    luminaries never updated both show '---'.
   */
  getFechaOTACorrecta(luminaria: luminaria) {
    if (luminaria.otaEstado == null || luminaria.otaEstado.fechaOtaCorrecta == null
      || luminaria.otaEstado.fechaOtaCorrecta == "") {
      return '---';
    }
    return new DatePipe('en-US').transform(luminaria.otaEstado.fechaOtaCorrecta, 'dd/MM/yyyy HH:mm');
  }

  // True once a finished OTA knows which version the luminary was updated from
  showVersionOrigen(luminaria: luminaria) {
    return luminaria.otaEstado.estado.includes("Done")
      && luminaria.otaEstado.versionOrigen != null && luminaria.otaEstado.versionOrigen != "";
  }

  /*
    The version the luminary reports after rebooting should appear in the name of the firmware
    file that was sent to it (4.16 in LUM_FW_4.16_EB03_DALI_LOGS.bin). It has to be the whole
    number, not part of a longer one: 4.1 and 4.16 do not match a 4.160 or a 4.16.2 file.
   */
  checkVersionOTA(luminaria: luminaria) {
    let version = luminaria.versionFirmware;
    let firmware = luminaria.otaEstado.firmwareOTA;
    if (version == null || version == "" || firmware == null || firmware == "") {
      return false;
    }
    let versionRegex = new RegExp("(^|[^0-9.])" + version.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "(?![0-9])(?!\\.[0-9])", "i");
    return versionRegex.test(firmware);
  }

  changeSortFirmwares(searcher: HTMLInputElement) {
    this.sortFirmwares = (this.sortFirmwares + 1) % 3;
    searcher.focus();
  }

  getSortFirmwaresIcon() {
    if (this.sortFirmwares == 1) {
      return "arrow_upward";
    } else if (this.sortFirmwares == 2) {
      return "arrow_downward";
    } else {
      return "swap_vert";
    }
  }

  getSortFirmwaresTooltip() {
    if (this.sortFirmwares == 1) {
      return this.localiser.get("ota.sortFirmwareAsc");
    } else if (this.sortFirmwares == 2) {
      return this.localiser.get("ota.sortFirmwareDesc");
    } else {
      return this.localiser.get("ota.sortFirmwareNone");
    }
  }

  openFirmwareSelect(luminaria: luminaria, opened: boolean, searcher: HTMLInputElement) {
    this.searcherFirmwares = "";
    this.searcherFirmwaresLum = opened ? luminaria.idDispositivo : "";
    if (opened) {
      setTimeout(() => searcher.focus());
    }
  }

  // Keeps the typed text in the searcher instead of letting mat-select use it for its own typeahead
  searcherFirmwaresKeydown(event: KeyboardEvent) {
    let keysForSelect = ["Escape", "Enter", "Tab", "ArrowUp", "ArrowDown"];
    if (!keysForSelect.includes(event.key)) {
      event.stopPropagation();
    }
  }

  setFirmware(luminaria: luminaria, firmware) {
    this.otaService.setFirmware(luminaria.idDispositivo, firmware).subscribe(result => { })
  }

  buttonActualizacion(ota_type: number) {
    if (this.queueOTALums.length > 0) {
      if (ota_type == 0) {
        this.otaService.actualizacion(this.queueOTALums[0].idDispositivo).subscribe(result => {
          if (!this.reloading) {
            this.startReloadLums();
          }
        });
      } else {
        this.otaService.actualizacionAutomatica(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
          this.automaticOTAstarted = true;
          if (!this.reloading) {
            this.startReloadLums();
          }
        });
      }
    }
  }

  abortOTA() {
    let mac_luminaria = undefined;

    if (this.lumForOTA != undefined && this.lumForOTA.length > 0 && this.lumForOTA[0].idDispositivo != undefined) {
      mac_luminaria = this.lumForOTA[0].idDispositivo;
    }

    this.otaService.abort(mac_luminaria, this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.automaticOTAstarted = false;
      this.getLuminarias();
    })
  }

  openFinishedListFunc() {
    this.openFinishedList = !this.openFinishedList;
  }

  openQueueListFunc() {
    this.openQueueList = !this.openQueueList;
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
